import { Compass, Layers, Hammer, ShieldCheck } from "lucide-react";

const stages = [
  {
    icon: Compass,
    n: "01",
    title: "Consultation",
    body: "We visit, measure and listen — understanding how you live before suggesting any layout.",
  },
  {
    icon: Layers,
    n: "02",
    title: "Design & Quote",
    body: "Detailed plans, specifications and a fully itemised, fixed-price quotation. No surprises.",
  },
  {
    icon: Hammer,
    n: "03",
    title: "Installation",
    body: "Our trade team delivers the build — clean site, tidy work and respect for your home.",
  },
  {
    icon: ShieldCheck,
    n: "04",
    title: "Aftercare",
    body: "12-month workmanship guarantee with a quick-response support number for any issues.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5">
          <span className="uppercase text-xs tracking-[0.3em] text-[#C9A24A] font-semibold">
            About C4
          </span>
          <h2
            data-testid="about-title"
            className="mt-4 font-heading text-3xl lg:text-5xl text-[#1C2A39] font-medium tracking-tight"
          >
            Professional. Reliable. Custom design to suit all.
          </h2>
          <p className="mt-6 text-base lg:text-lg text-[#5C6670] leading-relaxed">
            C4 Plumbing &amp; Heating Ltd is a bathroom, kitchen and plumbing
            company who specialise in design and installation, based in
            Warsash and covering all of Hampshire and parts of Dorset. With
            30+ verified reviews on Checkatrade and a rating of 10/10.
          </p>
          <div className="mt-10 grid grid-cols-3 gap-8">
            <div data-testid="about-stat-years">
              <div className="font-heading text-4xl text-[#C9A24A] font-medium">11+</div>
              <div className="mt-1 text-xs uppercase tracking-[0.18em] text-[#5C6670]">
                Years on tools
              </div>
            </div>
            <div data-testid="about-stat-projects">
              <div className="font-heading text-4xl text-[#C9A24A] font-medium">32+</div>
              <div className="mt-1 text-xs uppercase tracking-[0.18em] text-[#5C6670]">
                Verified reviews
              </div>
            </div>
            <div data-testid="about-stat-rating">
              <div className="font-heading text-4xl text-[#C9A24A] font-medium">10/10</div>
              <div className="mt-1 text-xs uppercase tracking-[0.18em] text-[#5C6670]">
                Checkatrade
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="grid sm:grid-cols-2 gap-px bg-[#E8E5DD]">
            {stages.map((s) => (
              <div
                key={s.n}
                data-testid={`about-stage-${s.n}`}
                className="bg-[#F9F8F6] p-8 hover:bg-white transition-colors"
              >
                <div className="flex items-baseline gap-3">
                  <span className="font-heading text-xs tracking-[0.3em] text-[#C9A24A] font-semibold">
                    {s.n}
                  </span>
                  <s.icon size={18} strokeWidth={1.5} className="text-[#1C2A39]" />
                </div>
                <h3 className="mt-4 font-heading text-xl text-[#1C2A39] font-semibold">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-[#5C6670] leading-relaxed">
                  {s.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
